import { Inject } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

export class MatPaginatorIntlCustom extends MatPaginatorIntl {
    constructor(@Inject(TranslateService) private _translate: TranslateService) {
        super();

        this._translate
            .stream([
                'MAT_TABLE.PAGINATOR.ITEMS_PER_PAGE',
                'MAT_TABLE.PAGINATOR.PREVIOUS_PAGE',
                'MAT_TABLE.PAGINATOR.NEXT_PAGE',
                'MAT_TABLE.PAGINATOR.FIRST_PAGE',
                'MAT_TABLE.PAGINATOR.LAST_PAGE',
                'MAT_TABLE.PAGINATOR.RANGE'
            ])
            .subscribe(translations => {
                this.itemsPerPageLabel = translations['MAT_TABLE.PAGINATOR.ITEMS_PER_PAGE'];
                this.previousPageLabel = translations['MAT_TABLE.PAGINATOR.PREVIOUS_PAGE'];
                this.nextPageLabel = translations['MAT_TABLE.PAGINATOR.NEXT_PAGE'];
                this.firstPageLabel = translations['MAT_TABLE.PAGINATOR.FIRST_PAGE'];
                this.lastPageLabel = translations['MAT_TABLE.PAGINATOR.LAST_PAGE'];
                this.changes.next();
            });

        this.getRangeLabel = (page: number, pageSize: number, length: number) =>
            this._translate.instant('MAT_TABLE.PAGINATOR.RANGE', {
                start: page * pageSize + 1,
                end: Math.min(page * pageSize + pageSize, length),
                total: length
            });
    }
}
